import SEO from "../components/SEO";
import { useTheme } from "../context/ThemeContext";
import { Reveal } from "../components/motion/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  const { content, seo } = useTheme();
  return (
    <div className="max-w-3xl mx-auto px-4 py-16" data-testid="faq-page">
      <SEO title={seo.faq_title || "FAQ"} description={seo.faq_description || "Frequently asked questions about ordering, shipping, wholesale and returns at Humaira Crafts."} />
      <Reveal>
        <h1 className="text-4xl md:text-5xl tracking-tighter font-semibold mb-4" data-eid="faq-heading" data-etype="text">Frequently Asked Questions</h1>
        <p className="text-sm text-muted-foreground mb-12" data-eid="faq-intro" data-etype="text">Everything you need to know about ordering from Humaira Crafts.</p>
      </Reveal>
      <Accordion type="single" collapsible>
        {content.faq_items.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`}>
            <AccordionTrigger className="text-left font-serif text-lg" data-testid={`faq-q-${i}`}>{f.q}</AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
